import { useSearchParams } from 'react-router-dom';
import { authModalParams } from 'utils/routes';

const useSetAuthModalWithParams = () => {
  const [params, setParams] = useSearchParams();

  const { modal } = authModalParams;

  const modalShouldOpen = params.get('modal') === modal;
  const clearParams = () => {
    const param = params.get('modal');
    if (param) params.delete('modal');
    setParams(params);
  };

  return {
    modalShouldOpen,
    clearParams,
  };
};

export default useSetAuthModalWithParams;
